import { JsonObject, AbstractModel, JsonProperty, DateConverter } from '../../core/public-api';
import { ShortObject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-json-object';

@JsonObject('model.user.UserRole')
export class UserRole extends AbstractModel {
    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'name')
    name?: string;

}